import theme from '../../muiTheme';

const styles = {
      userAvatar: {
        borderRadius: '60px',
        width: '60px',
        height: '60px',
        backgroundColor: 'black',
        border: '2px solid white',
        boxSizing: 'content-box',
        cursor: 'pointer',
      },
      userInfo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginLeft: '10px',
        cursor: 'pointer',
      },
      userName: {
        color: 'black',
        fontWeight: 'normal'
      },
      createdAt: {
        color: theme.palette.gray,
        fontStyle: 'italic'
      },
      bio: {
        color: theme.palette.gray,
      },
      avatarContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        color: 'white',
      },
      userAvatar2: {
        borderRadius: '60px',
        width: '60px',
        height: '60px',
        backgroundColor: 'black',
        border: '2px solid white',
        boxSizing: 'content-box'
      },
      userInfo2: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginLeft: '10px',
        color: 'white'
      },
      userName2: {
        backgroundColor: '#0000004d',
        padding: '2px 10px',
        margin: '3px',
        borderRadius: '20px',
        color: 'white'
      },
      createdAt2: {
        backgroundColor: '#0000004d',
        padding: '2px 10px',
        margin: '3px',
        borderRadius: '20px',
        color: 'white',
        fontSize: '11px'
      },
}

export default styles; 